import { Consultant } from './../models/Consultant.model';
import { Search } from './../models/Search.model';
import { UrlBuilder } from './../models/utils/url-builder.model';
import { HashtrackService } from './hashTrack.service';
import { CommonHelper } from './../shared/helpers/CommonHelper';
import { DropDownList } from './../models/DropDownList.model';
import { Project } from './../models/Project.model';
import { CompanyFinancial } from './../models/project/CompanyFinancial.model';
import { CompanyGroupsFinancial } from './../models/project/CompanyGroupsFinancial.model';
import { ResponsibleFinancial } from './../models/project/ResponsibleFinancial.model';
import { ProjectFinancial } from './../models/project/ProjectFinancial.model';
import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";

@Injectable()
export class ProjectFinancialService {
    constructor(
        private httpClient: HttpClient,
        private hashtrackService: HashtrackService
    ) { }

    private endPointMaster: String = "/projectsFinancial";
    private endPointUsers: String = "/users";
    private endPointCompanies: String = "/companies";
    private endPointConsultants: String = "/consultants";
    private endPointSubDivision: String = "/subDivision";
    private endPointTeamGroups: String = "/team-groups";

    async create(projectFinancial: ProjectFinancial) {
       delete projectFinancial._id;
       return await this.httpClient.post(this.endPointMaster, projectFinancial);
    }

    async getById(id): Promise<ProjectFinancial> {
        var jsonRes = await this.httpClient.get(`${this.endPointMaster}/${id}`);
        var pjFinacial = new ProjectFinancial();
        pjFinacial.loadFromServer(jsonRes);
        return pjFinacial;
    }

    async update(projectsFinancial:ProjectFinancial){
        return await this.httpClient.update(this.endPointMaster, projectsFinancial._id,projectsFinancial)
    }

    async getFilterProjectsFinancial(projectsSearch): Promise<Search> {
        const builder = new UrlBuilder([
            { key: "skip", value: projectsSearch.findResults.skip },
            { key: "limit", value: projectsSearch.findResults.limit }
        ]);
        var keyValueParams = [];

        for (let project of projectsSearch.projects)
            keyValueParams.push({ key: "projects", value: project });

        for (let client of projectsSearch.clients)
            keyValueParams.push({ key: "company", value: client });

        for (let responsible of projectsSearch.responsibles)
            keyValueParams.push({ key: "userResponsible", value: responsible });

        for (let proHash of projectsSearch.projectHash)
            keyValueParams.push({ key: "hashTrack", value: proHash });

        for (let consultant of projectsSearch.consultants)
            keyValueParams.push({ key: "consultant", value: consultant });

        for (let subDivision of projectsSearch.subDivisions)
            keyValueParams.push({ key: "subDivision", value: subDivision });

        for (let status of projectsSearch.projectActive)
            keyValueParams.push({ key: "projectActive", value: status });

        for (let center of projectsSearch.excellenceCenters)
            keyValueParams.push({ key: 'excellenceCenters', value: center });

        for (let companyGroup of projectsSearch.companyGroups)
            keyValueParams.push({ key: "companyGroups", value: companyGroup })

        builder.addQueryStringParamsInsideFilter(keyValueParams);

        var projectsJSON = await this.httpClient.get(builder.buildUrl(`${this.endPointMaster}`));
        var projects = new Array<ProjectFinancial>();

        await projectsJSON.search.forEach(com => {
            var projectsModel= new ProjectFinancial();
            projectsModel.loadFromServer(com);
            projects.push(projectsModel);
        });

        projectsSearch.findResults.totalItems = projectsJSON.total;
        projectsSearch.findResults.anotherModel = projects;
        return projectsSearch.findResults;
    }

    async getProjectsFinancialByCompany(id): Promise<ProjectFinancial[]> {
        var projectsJSON = await this.httpClient.get(`${this.endPointMaster}/${id}/company`);
        var projects = new Array<ProjectFinancial>();

        projectsJSON.forEach(com => {
            var projectsModel= new ProjectFinancial();
            projectsModel.loadFromServer(com);
            projects.push(projectsModel);
        });

        return projects;
    }

    async getProjectByGroupId(id): Promise<ProjectFinancial[]>  {
        let projects = new Array<ProjectFinancial>();
        let projectsServer = await this.httpClient.get(`${this.endPointMaster}/group`, `/${id}`);
        for (let p of projectsServer) {
          let proj = new ProjectFinancial();
          proj.loadFromServer(p);
          projects.push(proj);
        }
        return projectsServer;
    }

    async getAllProjectsFinancial(): Promise<ProjectFinancial[]> {
        var projectsJSON = await this.httpClient.get(this.endPointMaster);
        var projects = new Array<ProjectFinancial>();
        projectsJSON.search.forEach(com => {
            var projectsModel= new ProjectFinancial();
            projectsModel.loadFromServer(com);
            projects.push(projectsModel);
        });

        return projects;
    }

    async getAllCompany(hasGroup): Promise<CompanyFinancial[]> {
        const endPointCompanies = !hasGroup ? `${this.endPointCompanies}?filter=onlyCustomer=true` :
            `/companies/group/${hasGroup}/companies`;
        var companiesJSON = await this.httpClient.get(endPointCompanies);
        var companies = new Array<CompanyFinancial>();

        companiesJSON.companies.forEach(com => {
            var companyModel= new CompanyFinancial();
            companyModel.loadFromServer(com);
            companies.push(companyModel);
        });

        return companies;
    }

    async getAllCompanyGroups(): Promise<CompanyGroupsFinancial[]> {
        var companyGroupsJSON = await this.httpClient.get(`${this.endPointCompanies}/group`);
        var companyGroups = new Array<CompanyGroupsFinancial>();

        companyGroupsJSON.groups.forEach(cg => {
            var companyGroupModel = new CompanyGroupsFinancial();
            companyGroupModel.loadFromServer(cg);
            companyGroups.push(companyGroupModel);
        });

        return companyGroups;
    }

    async getAllResponsable(): Promise<ResponsibleFinancial[]> {
        var usersJSON = await this.httpClient.get(this.endPointUsers);
        var responsibles = new Array<ResponsibleFinancial>();

        usersJSON.forEach(u => {
            var responsibleModel = new ResponsibleFinancial();
            responsibleModel.loadFromServer(u);
            responsibles.push(responsibleModel);
        });

        return responsibles;
    }

    async getAllConsultants(): Promise<Consultant[]> {
        var consultantsJSON = await this.httpClient.get(this.endPointConsultants);
        var consultants = new Array<Consultant>();

        consultantsJSON.forEach(c => {
            var consultantModel = new Consultant();
            consultantModel.loadConsultantFromServer(c);
            delete consultantModel.payment;
            delete consultantModel.emergency;
            delete consultantModel.personal;
            delete consultantModel.responsible;
            delete consultantModel.contract;
            consultants.push(consultantModel);
        });

        return consultants;
    }

    async getAllProjectHashTrack(): Promise<Project[]> {
        let projectsHash = new Array<Project>();
        let res = await this.hashtrackService.getAllProjects();

        res.forEach(element => {
            let project = new Project();
            element.owner = undefined;
            element.company = undefined;
            project.loadFromServer(element);
            delete project.company;
            delete project.owner;
            projectsHash.push(project);
        });

        return projectsHash;
    }

    async getAllProject(): Promise<Project[]> {
        let projectsHash = new Array<Project>();
        projectsHash = await this.getAllProjectHashTrack();
        let projectFinancial = await this.httpClient.get(`${this.endPointMaster}/projects`);

        projectFinancial.forEach(element => {
            element.hashTrack.forEach(elemIds => {
                var indexElem = projectsHash.findIndex(fnd => fnd._id == elemIds._id);
                if (indexElem > -1) {
                    projectsHash.splice(indexElem, 1);
                }
            });
        });
        return projectsHash;
    }

    async getAllProjectEdit(id): Promise<Project[]> {
        let projectsHash = new Array<Project>();
        projectsHash = await this.getAllProjectHashTrack();
        let projectFinancial = await this.httpClient.get(`${this.endPointMaster}/projects`);

        projectFinancial.forEach(element => {
            if (element._id != id) {
                element.hashTrack.forEach(elemIds => {
                    var indexElem = projectsHash.findIndex(fnd => fnd._id == elemIds._id);
                    if (indexElem > -1) {
                        projectsHash.splice(indexElem, 1);
                    }
                });
            }
        });

        return projectsHash;
    }

    async getProjectsAndCustomers() {
        let response = await this.httpClient.get(`${this.endPointMaster}/projectAndCustomers`);
        return response;
    }

    async getCustomerAndProject(idHash) {
        let response = await this.httpClient.get(`${this.endPointMaster}/projectAndCompany/${idHash}`);
        return response;
    }

    createPropertyObjDropDown(arrayValue: any, single: boolean = false, name: string, pluralName: string, params = [], groupBy = null) {
        let obj = {
            dropDownList: new Array<DropDownList>(),
            selectedItems:new Array<DropDownList>(),
            dropDownSettings: {},
            commonHelper: new CommonHelper()
        }
        obj.dropDownList = obj.commonHelper.getDropDownListItems(arrayValue, "_id", "name", params);
        obj.dropDownSettings = obj.commonHelper.getDropDownSettings(single, name, false, `Marcar todos os ${pluralName}`, `Desmarcar todos os ${pluralName}`, true,groupBy, '');
        return obj;
    }

    async preSelectItensDropDown(projects, pjFinancialId) {
        var objProjectCompany = await this.createPropertyObjDropDown(projects, true, "Projetos", "projetos");
        var selectProject = objProjectCompany.dropDownList.find(fnd => fnd.id == pjFinancialId);
        if (selectProject !== undefined) {
            objProjectCompany.selectedItems.push(selectProject);
        }
        return objProjectCompany;
    }

    async getCostAndIncomes(id) {
        try{
            let response = await this.httpClient.get(`${this.endPointMaster}/${id}/costandincomes`);
            return response;
        }catch(err){
            return {projects:null,successIncome:false,successCost:false};
        }

    }

    async getAllSubDivisions(): Promise<any> {
        try {
            let response = await this.httpClient.get(`${this.endPointSubDivision}`);
            return response;
        } catch(err) {
            return {err}
        }
    }

    async getSubDivisionsByDivision(code) {
        try {
            let response = await this.httpClient.get(`${this.endPointSubDivision}/division/${code}`);
            return response;
        } catch(err) {
            return {err}
        }
    }

    async getAllTeamGroups() {
        let teamGroups = await this.httpClient.get(`${this.endPointTeamGroups}/active`);
        return teamGroups;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/projectFinancial.service.ts